import { SVG } from '../SVG'

const GreenSmCheckIcon = ({ style = {}, ...props }) => (
  <SVG
    width='19'
    height='19'
    viewBox='0 0 19 19'
    fill='none'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
    style={{ ...style }}
    {...props}
  >
    <path
      d='M9.16469 16.467C12.9199 16.467 15.9641 13.3124 15.9641 9.42093C15.9641 5.5295 12.9199 2.37488 9.16469 2.37488C5.40945 2.37488 2.36523 5.5295 2.36523 9.42093C2.36523 13.3124 5.40945 16.467 9.16469 16.467Z'
      stroke='var(--success-color)'
    />
    <path d='M11.9985 7.65942L7.84087 11.7696L5.76562 9.71452' stroke='var(--success-color)' />
  </SVG>
)

export default GreenSmCheckIcon
